import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';

import Form from '../../Form';

class CopyPricesForm extends Form {
    static fieldTypesValidation = {
        sport: [ 'required' ]
    };

    static propTypes = {
        ...Form.propTypes,
        sports: ImmutablePropTypes.map,
    };

    static defaultProps = {
        ...Form.defaultProps,
    };

    constructor(props, context) {
        super(props, context);
    }

    onSubmit(e) {
        e.preventDefault();

        let { data } = this.state;
        this.props.onSubmit(data.sport);
    }

    renderForm() {
        const { sports } = this.props;
        let el;
        if (sports.size > 0) {
            el = (
                <div>
                    {
                        this.getField(
                            <select
                                label="Sport"
                                { ...this.getFieldParameters('sport') }
                            >
                                <option value="" />
                                {
                                    sports.entrySeq().map(([sport, sportData]) => (
                                        <option key={ sport } value={ sport }>
                                            { sportData.get('name') }
                                        </option>
                                    )).toArray()
                                }
                            </select>
                        )
                    }
                    <div className="buttons">
                        <button type="submit" className="btn">Confirm</button>
                    </div>
                </div>
            );
        } else {
            el = 'No sports loaded.';
        }

        return el;
    }
}

export default CopyPricesForm;
